import React from 'react';
import { IFormData } from '../BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';

interface IBusinessDetailContext {
  data: IFormData | undefined;
}

const BusinessDetailContext = React.createContext<IBusinessDetailContext>({
  data: undefined,
});

export default BusinessDetailContext;
